var _circle, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 62,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.167,
    cy: 31,
    r: 30.5,
    fill: "#fff",
    stroke: "#3C3C3C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 22,
    width: 44,
    height: 21,
    rx: 10.5,
    fill: "#E95832"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.333 29L37 36.333 33.667 33",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.937 27.06l1.33.056-4.242 9.94-1.33-.056 4.242-9.94zm-4.956.112c.42 0 .798.093 1.134.28.345.187.616.457.812.812.205.355.308.784.308 1.288 0 .485-.108.905-.322 1.26-.206.355-.48.63-.826.826-.336.187-.705.28-1.106.28-.41 0-.789-.093-1.134-.28a2.12 2.12 0 01-.812-.812c-.206-.355-.308-.78-.308-1.274 0-.485.102-.905.308-1.26.214-.355.494-.63.84-.826a2.205 2.205 0 011.106-.294zm0 1.022a1.03 1.03 0 00-.504.14 1.05 1.05 0 00-.392.434c-.103.196-.154.453-.154.77 0 .476.102.826.308 1.05a.99.99 0 00.742.322.979.979 0 00.504-.14c.158-.093.29-.238.392-.434.102-.205.154-.467.154-.784 0-.467-.108-.807-.322-1.022a.957.957 0 00-.728-.336zm7.07 4.074c.41 0 .784.093 1.12.28.336.177.602.443.798.798.205.355.308.784.308 1.288 0 .485-.103.905-.308 1.26-.206.355-.48.63-.826.826-.336.187-.7.28-1.092.28-.41 0-.789-.089-1.134-.266a2.092 2.092 0 01-.826-.812c-.196-.355-.294-.784-.294-1.288 0-.485.102-.905.308-1.26.205-.355.48-.625.826-.812a2.231 2.231 0 011.12-.294zm0 1.008a1.03 1.03 0 00-.504.14 1.145 1.145 0 00-.406.434c-.103.196-.154.453-.154.77 0 .476.102.826.308 1.05.214.224.466.336.756.336.177 0 .34-.047.49-.14.158-.103.29-.252.392-.448.102-.205.154-.467.154-.784 0-.457-.108-.798-.322-1.022-.206-.224-.444-.336-.714-.336z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/media/step_3.09f6a156.svg";
export { SvgStep3 as ReactComponent };